import Box from '@mui/material/Box';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import useMediaQuery from '@mui/material/useMediaQuery';
import PropTypes from 'prop-types';
import React from 'react';
import shadow from '../../../helpers/shadow';

const SmallBox = props => {
  const { borderRadius } = 8;

  const { title, value, iconColor, boxColor } = props;
  const { Icon } = props;

  const isMobileView = useMediaQuery('(max-width: 540px)');

  const useStyles = makeStyles()(() => ({
    paper: {
      backgroundColor: boxColor,
      boxShadow: shadow.xl,
      borderRadius: 16,
      display: 'flex',
      overflow: 'hidden',
      margin: isMobileView ? undefined : '1em 2em 0 0',
    },
    valueBox: { minHeight: '1.5em' },
    iconSpan: {
      width: 70,
      backgroundColor: iconColor,
      borderRadius: `${borderRadius}px 0 0 ${borderRadius}px`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
    },
    icon: {
      height: 38,
      width: 38,
      maxWidth: '100%',
      color: 'white',
    },
    content: {
      padding: '10px',
      backgroundColor: boxColor,
      borderRadius: `0 ${borderRadius}px ${borderRadius}px 0`,
      color: 'white',
    },
    titleColor: {
      color: 'rgba(256,256,256,0.8)',
      minHeight: isMobileView ? '3.3em' : undefined,
    },
  }));

  const { classes } = useStyles();

  return (
    <div className={classes.paper}>
      <span className={classes.iconSpan}>
        <Icon className={classes.icon} />
      </span>
      <div className={classes.content}>
        <Typography color="inherit" variant="h5" component="span">
          <Box fontWeight="fontWeightBold" className={classes.valueBox}>
            {value > 1000 ? `${Math.round(value / 1000)}k` : value}
          </Box>
        </Typography>
        <div className={classes.titleColor}>
          <Typography color="inherit" variant="body1" component="span">
            {title}
          </Typography>
        </div>
      </div>
    </div>
  );
};

SmallBox.propTypes = {
  Icon: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  iconColor: PropTypes.string.isRequired,
  boxColor: PropTypes.string.isRequired,
};

export default SmallBox;
